import PropTypes from "prop-types";
import { TextField, Box } from "@mui/material";

function TimeField({ displayName, fieldRef, options }) {
  // console.log(options);
  return (
    <Box>
      <TextField
        name={fieldRef}
        id={`dff_${fieldRef}`}
        margin="dense"
        label={displayName}
        type="time"
        fullWidth
        variant="outlined"
        options={options}
        InputLabelProps={{
          sx: {
            whiteSpace: 'break-spaces',
          },
          shrink: true
        }}
      />
    </Box>
  );
}

// Typechecking props of the Transaction
TimeField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

TimeField.defaultProps = {
  options: null,
};

export default TimeField;
